import styled, { css } from 'styled-components';

export const UlElement = styled.ul<{ columns?: number; isOverlay?: boolean }>`
  width: 100%;
  display: flex;
  ${({ isOverlay }) =>
    isOverlay
      ? css`
          flex-direction: column;
        `
      : css`
          flex-direction: row;
          flex-wrap: wrap;
          max-height: 240px;
        `}

  ${({ columns, isOverlay }) =>
    columns &&
    !isOverlay &&
    css`
      li:nth-child(even) {
        margin-left: auto;
      }
    `}
`;

const OverlayLi = css<{ isSelected?: boolean; isDisabled?: boolean }>`
  padding: 0 16px;
  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  }
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
    `}
`;

const ListLi = css<{ columns?: number; isSelected?: boolean; isDisabled?: boolean }>`
  outline: none;

  ${({ columns }) =>
    columns === 2 &&
    css`
      width: calc(50% - 16px);
    `}

  svg {
    margin-right: 8px;
    transition-duration: 0.2s, 0.2s;
    transition-timing-function: ease-in, ease-out;
    width: 20px;
    height: 20px;
    ${({ columns }) =>
      !columns &&
      css`
        margin-left: 8px;
        margin-right: 0px;
      `}

    rect {
      fill: #fff;
      stroke-width: 1;
      stroke: ${({ theme }) => theme.kallisto.color.common.black[200]};
    }
  }
  ${({ isSelected }) =>
    isSelected
      ? css`
          svg {
            rect {
              stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
              fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
            }
          }
        `
      : css`
          &:hover,
          &:focus {
            svg {
              rect {
                fill: #fff;
                stroke-width: 1;
                stroke: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
              }
            }
          }
        `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
      &:hover,
      &:focus {
        svg {
          rect {
            fill: #fff;
            stroke-width: 1;
            stroke: ${({ theme }) => theme.kallisto.color.common.black[200]};
          }
        }
      }
    `}
`;

export const LiElement = styled.li<{
  columns?: number;
  isSelected: boolean;
  isDisabled?: boolean;
  isOverlay?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  cursor: pointer;
  font-size: ${({ theme }) => theme.kallisto.font.size['200']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['300']};
  ${({ isOverlay }) => (isOverlay ? OverlayLi : ListLi)}
`;

export const LiElementLabel = styled.div`
  width: calc(100% - 28px);
`;

export const LiElementAddLabel = styled.div`
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
`;
